import Btn from '../utils/btn';

const func = $target => {

	window.loader.key('hotspots', function () {

		// jQuery.noConflict();
		console.log('hotspots loaded');

		var $uid = $target.data('uid'),
			$cid = $target.data('cid'),
			$editMode = $target.find('[data-id="edit-mode"]'),
			$hotspotContainer = $target.find('#hotspot'),
			$modal = $('#commentModal'),
			$modalContent = $modal.find('.modal-content'),
			$modalBody = $modal.find('.modal-body'),
			$commentContainer = $modal.find('.modal-body ul'),
			$form = $modal.find('form'),
			$commentInput = $form.find('textarea[name="comment"]'),
			$addBtn = new Btn($form.find('[data-id="add"]')),
			$deleteBtn = $modal.find('[data-id="delete"]');

		$hotspotContainer.hotspot({
			mode: "admin", // Switching to admin mode
			ajax: true, // Switching on the ajax
			ajaxOptions: {
				url: '/actions/twilio/media/get-hotspots',
				type: 'GET',
				dataType: 'json',
				data: {
					uid: $uid,
				}
			},
			tag: 'img', //optional (default is img)
			interactivity: "click",
			afterAdd: function (err, data) {

				var $newHotspot = $hotspotContainer.find('[data-temp="' + data.tempId + '"]');

				$deleteBtn.hide();
				$commentContainer.empty();

				$form.off('submit').on('submit', function (e) {

					e.preventDefault();

					var $comment = $commentInput.val();

					$addBtn.processed();
					$commentInput.val('');

					delete data.tempId;

					$.ajax({
						type: "POST",
						dataType: "json",
						url: "/actions/twilio/media/save-annotation",
						headers: {
							"X-CSRF-Token": window.csrfTokenValue,
						},
						data: {
							uid: $uid,
							cid: $cid,
							type: 'comment',
							data: data,
							comment: $comment,
						}
					}).done(function (responseData) {
						console.log('done');
						data.id = responseData.id;
						$newHotspot.attr('data-hotspot-id', responseData.id).removeAttr('data-temp');
					});

					$modal.modal('hide');
					$modal.unbind('hidden.bs.modal');

				});

				//delete hotspot if not saved
				$modal.off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
					$newHotspot.remove();
					$commentInput.val('');
				});

				$modal.modal('show');

			},
			afterClick: function (err, hotspot) {

				// var $deleteBtn = $modal.find('[data-id="delete"]');
				$deleteBtn.show();

				$deleteBtn.off('click').on('click', function (e) {
					e.preventDefault();

					var deleteConfirm = confirm("Are you sure you want to delete these comments?");

					if (deleteConfirm) {

						$.ajax({
							type: "POST",
							dataType: "json",
							url: "/actions/twilio/media/delete-hotspot",
							headers: {
								"X-CSRF-Token": window.csrfTokenValue,
							},
							data: { id: hotspot.id }
						}).done(function (data) {
							$hotspotContainer.find('[data-hotspot-id="' + hotspot.id + '"]').remove();
						});

						$modal.modal('hide');
					}

					$deleteBtn.blur();
				})

				if (hotspot.id != null) {
					getComments(hotspot.id);
				}

				$form.off('submit').on('submit', function (e) {

					e.preventDefault();

					var $comment = $commentInput.val();
					$addBtn.processed();
					$commentInput.val('');

					$.ajax({
						type: "POST",
						dataType: "json",
						url: "/actions/twilio/media/save-comment",
						headers: {
							"X-CSRF-Token": window.csrfTokenValue,
						},
						data: {
							id: hotspot.id,
							cid: $cid,
							uid: $uid,
							comment: $comment
						}
					}).done(function (responseData) {
						console.log('done save comment');
					});

					$modal.modal('hide');
				});

				$modal.modal('show');

			},
			afterResize: function () {
				if (!$editMode.is(':checked')) {
					$hotspotContainer.find('[data-id="overlay"]').removeClass('HotspotPlugin_Overlay');
				}
			}
		});

		$modal.on('shown.bs.modal', function (event) {
			$modalBody.animate({
				scrollTop: $modalBody[0].scrollHeight
			}, 300, function () {
				$modalContent.delay(1000).removeClass('loading');
			});
		});

		$hotspotContainer.find('[data-id="overlay"]').removeClass('HotspotPlugin_Overlay');

		$editMode.change(function () {

			var $hotspotOverlay = $hotspotContainer.find('[data-id="overlay"]');

			if (this.checked) {
				$hotspotOverlay.addClass('HotspotPlugin_Overlay');
			} else {
				$hotspotOverlay.removeClass('HotspotPlugin_Overlay');
			}
		});

		function getComments(id) {

			$commentContainer.empty();
			$modalContent.addClass('loading');

			$.ajax({
				type: "GET",
				dataType: "json",
				url: "/actions/twilio/media/get-comments",
				headers: {
					"X-CSRF-Token": window.csrfTokenValue,
				},
				data: {
					id: id
				}
			}).done(function (response) {

				$.each(response, function () {
					var data = this;
					var $li = $('<li class=" border-bottom d-block p-2 pl-3 text-break"></li>').html(`
						${data.comment}
						<br><span class="small text-muted">${data.name}</span><span class="small text-muted float-right">${data.dateCreated}</span></li>`
					);

					$commentContainer.append($li);
				});
			});

		}

		var params = window.uri.query().split('&');
		$.each(params, function () {
			var pair = this.split('=');
			if (pair[0] == 'hotspotid') {
				setTimeout(function () {
					$hotspotContainer.find('[data-hotspot-id="' + pair[1] + '"]').trigger('click');
				}, 500);
			}
		})

	});

}

export default func;